// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';

@observer class CircleLoader extends Component<any, any> {

	spinnerStyle: any = {};
	spinnerColor: any = {};

	constructor(props: any) {
		super(props);

		this.spinnerStyle = {
			width: props.size,
			height: props.size
		};

		this.spinnerColor = {
			backgroundColor: props.color ? props.color : '#F87B6F' 
		}
	}

	render() {
		return (
			<div className="spinner" style={this.spinnerStyle}>
				<div style={this.spinnerColor} className="double-bounce1"></div>
				<div style={this.spinnerColor} className="double-bounce2"></div>
			</div>
		)
	}
}

export default CircleLoader;

